import {inject, injectable} from 'inversify';

import type {BNFormApiModel} from '../../../../../api/types/bnrks/models';

import {QuestionModel} from '../../Question.model';
import {TextQuestionFactory} from '../TextQuestion.factory';

type Question = BNFormApiModel['sections'][0]['questions'][0];

@injectable()
export class TextQuestionMapperJrpc {
  constructor(
    @inject(TextQuestionFactory)
    private readonly factory: TextQuestionFactory,
  ) {}

  mapToModel(data: Question) {
    return this.factory.create({
      id: data.uuid,
      isRequired: !data.is_optional,
      title: data.question,
      type: this.type(data),
    });
  }

  type(data: Question) {
    const types: {[key in Question['type']]?: QuestionModel.Type} = {
      long_text: 'long_text',
      short_text: 'short_text',
    };

    const type = types[data.type];

    if (!type) {
      throw new Error(`Unknown question type: ${data.type}`);
    }

    return type;
  }
}
